const ActivityTypeMap = {
  click: {
    1: 'ZNCP-JH-m_click_106',
    2: 'ZNCP-JH-m_click_107',
    3: 'ZNCP-JH-m_click_104',
    4: 'ZNCP-JH-m_click_108',
    5: 'ZNCP-JH-m_click_105'
  },
  show: {
    1: 'ZNCP-JH-m_show_106',
    2: 'ZNCP-JH-m_show_107',
    3: 'ZNCP-JH-m_show_104',
    4: 'ZNCP-JH-m_show_108',
    5: 'ZNCP-JH-m_show_105'
  },
  pvareaId: {
    1: 6829247,
    2: 6829248,
    3: 6829244,
    4: 6829246,
    5: 6829245
  },
  eid: {
    1: '2|1211004|897|7098|205300|304207', // 红包雨
    2: '2|1211004|897|7098|205302|304209',// 拼图
    3: '2|1211004|897|7098|205301|304208',// 抽奖
    4: '2|1211004|897|7098|205303|304210', // 到店礼
    5: '2|1211004|897|7098|205304|304211'// 抢车模
  }
};
const SharePosterStatInfo = {
  saveShare: {
    0: { show: 'ZNZT_APP_activity_show_1', click: 'ZNZT_APP_activity_1' },
    6: { show: 'ZNZT_APP_activity_show_2', click: 'ZNZT_APP_activity_2' },
    1: { show: 'ZNZT_APP_activity_show_3', click: 'ZNZT_APP_activity_3' },
    3: { show: 'ZNZT_APP_activity_show_4', click: 'ZNZT_APP_activity_4' },
    4: { show: 'ZNZT_APP_activity_show_5', click: 'ZNZT_APP_activity_5' },
    5: { show: 'ZNZT_APP_activity_show_6', click: 'ZNZT_APP_activity_6' },
    2: { show: 'ZNZT_APP_activity_show_7', click: 'ZNZT_APP_activity_7' }
  },
  sharePickRedPacket: {
    6: { show: 'ZNZT_APP_activity_show_8', click: 'ZNZT_APP_activity_8' },
    1: { show: 'ZNZT_APP_activity_show_9', click: 'ZNZT_APP_activity_9' },
    3: { show: 'ZNZT_APP_activity_show_10', click: 'ZNZT_APP_activity_10' },
    4: { show: 'ZNZT_APP_activity_show_11', click: 'ZNZT_APP_activity_11' },
    5: { show: 'ZNZT_APP_activity_show_12', click: 'ZNZT_APP_activity_12' },
    2: { show: 'ZNZT_APP_activity_show_13', click: 'ZNZT_APP_activity_13' }
  }
};
import config from '../config/index';
import { URLService } from '../services/url.service';
export default {
  getActShowActionName (activityType) {
    var action = ActivityTypeMap.show[activityType];
    return action || '';
  },
  getActClickActionName (activityType) {
    var action = ActivityTypeMap.click[activityType];
    return action || '';
  },
  getActClickEidName (activityType) {
    var eid = ActivityTypeMap.eid[activityType];
    return eid || '';
  },
  buildActUrl (pvAreaId, activityId, activityType, salesId, channelId, channelType, eid) {
    let frompvareaid = ActivityTypeMap.pvareaId[activityType] || 0;
    var url = `${config.dealerCloud}/vr4s/game?busi=dealerVr`;
    const urlSerivce = new URLService(url);
    urlSerivce.queryParams
      .append('activityId', activityId)
      .append('activityId', activityType)
      .append('pvareaid', pvAreaId)
      .append('frompvareaid', frompvareaid)
      .append('salesId', salesId)
      .append('channelId', channelId)
      .append('channelType', channelType)
      .append('eid', eid),
    url = urlSerivce.build();
    console.log({ eid, url });
    return url;
  },
  getSharePosterStatInfo (operateType, activityType) {
    const stat = SharePosterStatInfo[operateType][activityType];
    return stat || { show: '', click: '' };
  }
};
